import { connect } from "react-redux";
import { UsuarioViewProps, mapDispatchToUsuarioProps, mapStateToUsuarioProps } from "../usuario.controller";
import { Usuario } from "../usuario.model";
import { Select as ViewList } from "../../../components/select";
import { Box, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { UsuarioCadastro } from "./usuario.cad";
 
export const columnsUsuario: GridColDef[] = [
    { field: 'nome', headerName: 'nome', flex: 3 },
    { field: 'login', headerName: 'Login Acesso', flex: 3 },
    { field: 'ativo', headerName: 'Ativo', flex: 2, renderCell:(prm)=>prm.value?"Sim":"Não" },
]

function UsuarioList(props: UsuarioViewProps) {
    const { usuarioActions,usuarioState } = props
    const { error, loadingRows, msg, row, rows, showAlert, showDialogExluir, status,showCadModal,changeList } = usuarioState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue,setShowCadModal } = usuarioActions
    console.log("UsuarioList props ",props)

    useEffect(()=>{
        read()
    },[])

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    const handleAlterar = (row: any) => {
        console.log("chamou handleAlterar")
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        console.log("chamou handleCloseCadastro")
        setShowCadModal(false)
    }

    function Cadastro() {
        return UsuarioCadastro({
            ...props,
            handleCloseView: handleCloseCadastro
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: showCadModal,
            heigth: "auto",
            width:"sm"
        })
    }

    const List = ()=>{
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Usuários Cadastrados"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"nome"}
                columns={columnsUsuario}
                rows={rows}
                loading={loadingRows}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick:()=>read()
                }}
                ListItemTextPrimary={(row: Usuario) => <Typography component={"span"}>{row.nome}</Typography>}
                ListItemTextSecondary={(row: Usuario) =>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography component={"span"}>{row.login}</Typography>
                        <Typography component={"span"}>{row.ativo?"Ativo":"Inativo"}</Typography>
                    </Box>
                }
            />
        )
    }

    return (
        <div className="modulo">
            <Cadastro />
            <List />
        </div>
    )

}

export default connect(mapStateToUsuarioProps,mapDispatchToUsuarioProps)(UsuarioList);
